export const EVENT_SERIES_TYPE = 'event';
